export const durationPatterns = [
    '^(\\d)$',
    '^(\\d+)$',
    '^(\\d+)h(ours)?$',
    '^(\\d+)m(in)?s?$',
    '^([0-2]?[0-9])[\\.\\,](\\d+)h?$',
    '^([0-2]?[0-9])\\:([0-5][0-9])$'
];

export const startTimePatterns = [
    '^(\\d+)$',
    '^(\\d+)h(ours)?$',
    '^([0-2]?[0-9])\\:([0-5][0-9])$'
];

export const quotaValidation = new RegExp(/^[0-9]*$/);



/** WEBPACK FOOTER **
 ** ./src/app/constants.js
 **/